import { computed, action, observable, reaction } from "mobx";
import { PeriodConverter, history, updateUrlParams } from "@state";
import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";
import BaseEventViewStore from "./BaseEventViewStore";
import { Period } from "@state/common/PeriodConverter";

const MY_BET_DESKTOP_SEPARATOR = "-myBets";
export default class EventViewStore extends BaseEventViewStore {
	@observable isFirstLoad = true;

	@computed get isLoading() {
		return (
			this.loader.isLoading ||
			(this.liveOfferMenuStore != null &&
				this.liveOfferMenuStore.isLoading &&
				!this.hasLiveEvents)
		);
	}

	@computed get hasLiveEvents() {
		return this.events.find((event) => event.isLive);
	}

	@computed get getHeaderInfo() {
		return history.location.state?.headerInfo || null;
	}

	@action.bound
	public setDisplayBettingGroup(value: string): void {
		if (value !== this.displayBettingGroup) {
			this.displayBettingGroup = value;
		}
	}

	@action.bound
	public async updateEventIds(
		rawEventId: string,
		period: Period | string = PeriodConverter.GetDefaultPeriod()
	): Promise<void> {
		if (this.eventIdsRaw != "/" + rawEventId) {
			this.eventIdsRaw = "/" + rawEventId;
		}
		const isDesktopNavigation = rawEventId.indexOf(
			MY_BET_DESKTOP_SEPARATOR
		);
		if (isDesktopNavigation != -1) {
			rawEventId = rawEventId.slice(0, isDesktopNavigation);
		}
		if (!this.isMultiEvent) {
			this.resetDisplayBettingGroup();
		}
		if (this.event || this.eventId) {
			this.rootStore.betBuilderStore.removeAdditionalOfferStore({
				id: this.event?.id || this.eventId,
			});
		}

		await this.onInitialize(rawEventId, period);
	}

	@action.bound
	handleUrls(myBetsToggleValue: boolean) {
		updateUrlParams({ myBets: myBetsToggleValue }, true);
	}

	@action.bound
	public async onInitialize(
		id: string,
		period: Period | string = PeriodConverter.GetDefaultPeriod()
	): Promise<void> {
		this.disposeSubscription();
		this.readSearchParamsOnLoad();
		this.betBoosterEventPicks.onDispose();
		const eventId = id;
		if (!eventId) {
			return;
		}

		if (eventId.includes("events")) {
			console.error(
				"EventIdsRaw is equal to 'events', could not fetch offer!"
			);
			return;
		}
		this.eventId = eventId;

		if (this.isLive) {
			this.initializeLiveOffer(this.eventId);
		} else {
			await this.initializePrematchOffer(this.eventId, period);
		}

		this.favoritesBettingTypeReaction = reaction(
			() =>
				JSON.stringify(this.favoritesStore.userFavoriteBettingTypesMap),

			() => {
				this.updateEventsMap();
			}
		);

		if (this.isFirstLoad) {
			const areMyBetsToggled =
				new URLSearchParams(window.location.search).get("myBets") ===
				"true";

			if (areMyBetsToggled) {
				this.openTab(EventBodyTabs.MyBets);
			} else {
				this.openTab(EventBodyTabs.Markets);
			}

			this.isFirstLoad = false;
		} else {
			this.openTab(EventBodyTabs.Markets);
		}

		this.rootStore.betBuilderStore.addAdditionalOfferStore(this);
	}
}
